export const AJOUTE_CLIENT = "AJOUTE_CLIENT";
export const SUPRIMER_CLIENT = "SUPRIMER_CLIENT";